import { createContext, useContext, useState } from "react";
import { ProjectQueryWizard } from "./ProjectQueryWizard";

const WizardContext = createContext({ openWizard: () => {} });

export const useWizard = () => useContext(WizardContext);

export const WizardProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [presetCategory, setPresetCategory] = useState(null);

  const openWizard = (category = null) => {
    setPresetCategory(category);
    setOpen(true);
  };

  return (
    <WizardContext.Provider value={{ openWizard }}>
      {children}
      <ProjectQueryWizard open={open} onOpenChange={setOpen} presetCategory={presetCategory} />
    </WizardContext.Provider>
  );
};
